import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HugeiconsIcon } from "@hugeicons/react";
import { CircleArrowRight02Icon } from "@/lib/hugeicons";
import { Download01Icon } from "@/lib/hugeicons";

interface SiteHeaderProps {
  onFeaturesClick?: () => void;
  onPricingClick?: () => void;
}

export function SiteHeader({ onFeaturesClick, onPricingClick }: SiteHeaderProps) {
  const navigate = useNavigate();

  const handleFeatures = () => {
    if (onFeaturesClick) onFeaturesClick();
    else navigate("/#features");
  };
  const handlePricing = () => {
    if (onPricingClick) onPricingClick();
    else navigate("/#pricing");
  };

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center gap-2">
          <img
            src="/splitsy-logo.png"
            alt="Splitsy logo"
            width={125}
            height={32}
            loading="eager"
            decoding="async"
            className="h-8 w-auto"
          />
        </button>
        <nav className="hidden md:flex items-center gap-1">
          <Button variant="ghost" onClick={handleFeatures}>
            Features
          </Button>
          <Button variant="ghost" onClick={handlePricing}>
            Pricing
          </Button>
        </nav>
        <div className="flex items-center gap-3">
          <Button variant="secondary" size="sm" onClick={() => navigate("/auth?mode=login")}>
            Log in
          </Button>
          <Button variant="ios" size="sm" onClick={() => navigate("/auth?mode=login")}>
            Get Started
          </Button>
        </div>
      </div>
    </header>
  );
}
